import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(protected)/dashboard/page.tsx");
